import { render, staticRenderFns } from "./SendSuccess.vue?vue&type=template&id=80e95484"
import script from "./SendSuccess.vue?vue&type=script&lang=js"
export * from "./SendSuccess.vue?vue&type=script&lang=js"
import style0 from "./SendSuccess.vue?vue&type=style&index=0&id=80e95484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports